import { isFeatureEnabled, SupportedFeatures } from '@/helpers/featureFlagUtils';
import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

export function useProjectBoostFeature(): ComputedRef<boolean> {
  const route = useRoute();

  return computed(() => isFeatureEnabled(SupportedFeatures.PROJECT_BOOST, route));
}
